import { AfterViewInit, Component, ElementRef, Input, OnChanges } from "@angular/core";
import { IPolyline } from "../../../../../../scripts/typings/google.maps.angular";
import { IJourney } from "../../../../interfaces/IJourney";
import { HTMLService } from "../../../../services/htmlService.service";
import { JourneyService } from "../../../../services/journey.service";
import { IVeriMapComponent } from "../veriMapComponent/veriMap.component";

@Component({
    selector: "veri-map-journeys-new",
    template: require("./veriMapJourneysNew.component.html")
})
export class VeriMapJourneysNewComponent implements OnChanges, AfterViewInit {
    @Input() polylines: IPolyline[];
    @Input() journeys: IJourney[];

    // ---

    private veriMap: IVeriMapComponent;

    constructor(
        private readonly elementRef: ElementRef,
        private readonly htmlService: HTMLService,
        private readonly journeyService: JourneyService) { }

    ngAfterViewInit() {
        this.findAndRegisterVeriMap();
    }

    ngOnChanges() {
        if (this.journeys) {
            this.polylines = this.journeys.map(j => this.journeyService.createJourneyPolyline(j));
        }

    }

    // ---

    private findAndRegisterVeriMap() {
        const veriMapHTML = this.htmlService.findNearest(this.elementRef.nativeElement, "veri-map");
        this.veriMap = this.htmlService.getAngularJSComponentFromElement<IVeriMapComponent>(veriMapHTML);

        console.log(this.veriMap);
        this.veriMap.fitMap(this.polylines[0].path);
    }
}
